/* eslint-disable */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Loading } from '@binance-chain/honeycomb'

import FormInput from '../../components/exchange/Input'
import FontNumber from '../../components/common/FontNumber'
import { Button } from '../../components/common/Button'
import { roundValue, decimalPlaces } from '../../utils/number'
import { withI18n } from '../../i18n/util'
import getUsdPrice from 'utils/price'

const Wrapper = styled.div`
  background: ${({ theme }) => theme.exchangeSecondBg};
  width: 100%;
  font-size: 14px;
  @media (max-width: 350px) {
    font-size: 12px;
  }
`
const Content = styled.div`
  color: #848e9c;
`

const FormRow = styled.div`
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  font-weight: 500;
  .inputWrap {
    background: rgba(33, 40, 51, 0.5);
    .unit {
      color: #48515d;
    }
  }
  input {
    font-size: 14px;
    color: #fff;
    ::-webkit-input-placeholder {
      color: #48515d;
      font-size: 14px;
    }
  }
`

const FormCol = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: ${({ align }) => (align ? align : 'center')};
  position: relative;
  width: 100%;
  color: #fff;
  white-space: nowrap;
  .title {
    color: #828a98;
    margin-right: 10px;
  }
  span {
    line-height: 14px;
  }
`
const Percentage = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  margin: 5px 0;
  li {
    width: 20%;
    height: 22px;
    text-align: center;
    line-height: 23px;
    border: 1px solid rgba(72, 81, 93, 1);
    transition: all 0.3s ease-in;
    border-radius: 3px;
    color: #828a98;
    cursor: pointer;
  }
`

const PlaceOrderButton = styled(Button)`
  width: 100%;
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  background: ${({ type }) =>
    type === 1
      ? 'linear-gradient(90deg,rgba(0,192,135,1),rgba(65,222,221,1))'
      : 'linear-gradient(90deg,rgba(234,0,112,1),rgba(252,84,179,1))'};
  span {
    line-height: inherit;
  }
`

const BuySellLabel = styled.span`
  padding-right: .5em;
`

class OrderFormMobile extends PureComponent {
  static propTypes = {
    baseAsset: PropTypes.string,
    quoteAsset: PropTypes.string,
    tickerSize: PropTypes.string,
    lotSize: PropTypes.string,
    dispatch: PropTypes.func,
    amount: PropTypes.string,
    xBNBPair: PropTypes.string,
    availableBalance: PropTypes.number,
    cryptoCurrencyRate: PropTypes.object,
    type: PropTypes.number,
    onClick: PropTypes.func,
    formatI18nText: PropTypes.func,
    isLoading: PropTypes.bool,
  }

  static defaultProps = {
    baseAsset: '',
    quoteAsset: '',
    amount: '',
    price: '',
    xBNBPair: '',
    tickerSize: '0.00000001',
    lotSize: '0.00000001',
    availableBalance: 0,
    cryptoCurrencyRate: {},
    type: 1, // 1 - buy, 2 - sell
    dispatch: () => {},
    onClick: () => {},
    formatI18nText: () => {},
    isLoading: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      price: props.price,
      amount: props.amount,
      maxBuyAmount: 0,
      total: '',
    }
  }

  componentDidUpdate(prevProps) {
    const { amount, price, tickerSize, lotSize } = this.props

    if (amount !== prevProps.amount || price !== prevProps.price) {
      const roundAmount = roundValue(amount, lotSize) || ''
      const roundPrice = roundValue(price, tickerSize)
      const roundTotal = roundAmount ? roundValue(roundAmount * roundPrice, tickerSize) : ''

      this.setState({
        amount: roundAmount,
        price: roundPrice,
        total: roundTotal,
      })
    }
  }

  _calAmount = (total, price) => {
    const { type, tickerSize } = this.props
    price = parseFloat(price)
    //buy
    if (type === 1) {
      return roundValue(parseFloat(total, 10) / price, tickerSize)
    }

    //sell
    if (type === 2) {
      return roundValue(parseFloat(total, 10) * price, tickerSize)
    }
  }

  _getRoundSize = () => {
    const { tickerSize, lotSize } = this.props
    const ts = decimalPlaces(tickerSize)
    const ls = decimalPlaces(lotSize)
    return ts > ls ? tickerSize : lotSize
  }

  _calPercentage = percentage => {
    const { price } = this.state
    if (!price) return
    const { availableBalance, type } = this.props
    const roundSize = this._getRoundSize()
    const total = roundValue(availableBalance * percentage, roundSize)
    const amount = this._calAmount(total, price)
    this.setState({
      total: type === 1 ? total : amount,
      amount: type === 1 ? amount : total,
    })
  }

  _priceChange = price => {
    const { amount } = this.state
    const { tickerSize, availableBalance, lotSize } = this.props
    price = roundValue(price, tickerSize)
    let maxBuyAmount =
      price && roundValue(parseFloat(availableBalance) / parseFloat(price), lotSize)
    maxBuyAmount = maxBuyAmount ? maxBuyAmount : '0.0'

    if (amount) {
      this.setState({
        price,
        maxBuyAmount,
        total: price ? roundValue(parseFloat(price, 10) * parseFloat(amount, 10), tickerSize) : '',
      })
    } else {
      this.setState({ price, maxBuyAmount, total: '' })
    }
  }

  _amountChange = amount => {
    const { price } = this.state
    const { tickerSize, availableBalance, lotSize } = this.props
    amount = roundValue(amount, lotSize)
    let maxBuyAmount =
      price && roundValue(parseFloat(availableBalance) / parseFloat(price), lotSize)
    maxBuyAmount = maxBuyAmount ? maxBuyAmount : '0.0'

    if (price) {
      this.setState({
        amount,
        maxBuyAmount,
        total: amount ? roundValue(parseFloat(price, 10) * parseFloat(amount, 10), tickerSize) : '',
      })
    } else {
      this.setState({ amount, maxBuyAmount, total: '' })
    }
  }

  _totalChange = total => {
    const { price, amount } = this.state
    const { lotSize } = this.props
    if (!price && !amount) {
      this.setState({ total })
    } else {
      this.setState({
        total,
        amount: total ? roundValue(parseFloat(total, 10) / parseFloat(price, 10), lotSize) : '',
      })
    }
  }

  _placeOrder = ev => {
    document.activeElement.blur()
    const { price, amount, total } = this.state
    const { onClick } = this.props
    onClick && onClick(ev, price, amount, total)
  }

  render() {
    const {
      tickerSize,
      lotSize,
      type,
      quoteAsset,
      baseAsset,
      availableBalance,
      formatI18nText,
      cryptoCurrencyRate,
      xBNBPair,
      isLoading,
    } = this.props
    const { price, amount, total } = this.state
    const avbUnit = type === 1 ? quoteAsset.replace(/-.+/, '') : baseAsset.replace(/-.+/, '')
    const usdPrice = getUsdPrice(quoteAsset, xBNBPair, cryptoCurrencyRate, price)
    return (
      <Wrapper>
        <Content>
          <FormRow style={{ marginBottom: '10px' }}>
            <FormCol>
              <span className="title">{formatI18nText('orderForm.avb')}</span>
              <span style={{ fontFamily: 'DINNext' }}>{`${availableBalance} ${avbUnit}`}</span>
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol>
              <FormInput
                unit={quoteAsset.replace(/-.+/, '')}
                width="100%"
                height="36px"
                onChange={this._priceChange}
                step={tickerSize}
                min={tickerSize}
                value={price}
                placeOrder={formatI18nText('orderForm.price')}
              />
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol>
              <span className="title">
                {formatI18nText('orderForm.equivalent')}&nbsp;&nbsp;&nbsp; {usdPrice}
              </span>
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol>
              <FormInput
                unit={baseAsset.replace(/-.+/, '')}
                width="100%"
                height="36px"
                onChange={this._amountChange}
                step={lotSize}
                min={lotSize}
                value={amount}
                placeOrder={formatI18nText('orderForm.amount')}
              />
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol>
              <Percentage>
                <li
                  onClick={() => {
                    this._calPercentage(0.25)
                  }}
                >
                  <FontNumber value="25%" />
                </li>
                <li
                  onClick={() => {
                    this._calPercentage(0.5)
                  }}
                >
                  <FontNumber value="50%" />
                </li>
                <li
                  onClick={() => {
                    this._calPercentage(0.75)
                  }}
                >
                  <FontNumber value="75%" />
                </li>
                <li
                  onClick={() => {
                    this._calPercentage(1)
                  }}
                >
                  <FontNumber value="100%" />
                </li>
              </Percentage>
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol>
              <FormInput
                width="100%"
                placeOrder={`${formatI18nText('orderForm.total')}(${quoteAsset.replace(
                  /-.+/,
                  ''
                )})`}
                value={total}
                step={tickerSize}
                min={tickerSize}
                height="36px"
                onChange={this._totalChange}
              />
            </FormCol>
          </FormRow>
          <FormRow style={{ marginTop: '20px' }}>
            <FormCol>
              <PlaceOrderButton onClick={this._placeOrder} type={type} disabled={isLoading}>
                <BuySellLabel>
                  {type === 1 ? formatI18nText('orderForm.buy') : formatI18nText('orderForm.sell')}
                </BuySellLabel>
                { isLoading && <Loading /> }
              </PlaceOrderButton>
            </FormCol>
          </FormRow>
        </Content>
      </Wrapper>
    )
  }
}

export default withI18n(OrderFormMobile)
